"use strict";
/*
 * HSCollapse
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSCollapse = /** @class */ (function (_super) {
    __extends(HSCollapse, _super);
    function HSCollapse(el, options, events) {
        var _this = _super.call(this, el, options, events) || this;
        _this.contentId = _this.el.dataset.hsCollapse;
        _this.content = document.querySelector(_this.contentId);
        _this.animationInProcess = false;
        if (_this.content)
            _this.init();
        return _this;
    }
    HSCollapse.prototype.init = function () {
        var _this = this;
        var _a;
        this.createCollection(window.$hsCollapseCollection, this);
        if ((_a = this === null || this === void 0 ? void 0 : this.el) === null || _a === void 0 ? void 0 : _a.ariaExpanded) {
            if (this.el.classList.contains('open'))
                this.el.ariaExpanded = 'true';
            else
                this.el.ariaExpanded = 'false';
        }
        this.el.addEventListener('click', function () {
            if (_this.content.classList.contains('open')) {
                _this.hide();
            }
            else {
                _this.show();
            }
        });
    };
    HSCollapse.prototype.hideAllMegaMenuItems = function () {
        this.content
            .querySelectorAll('.hs-mega-menu-content.block')
            .forEach(function (el) {
            el.classList.remove('block');
            el.classList.add('hidden');
        });
    };
    // Public methods
    HSCollapse.prototype.show = function () {
        var _this = this;
        var _a;
        if (this.animationInProcess || this.el.classList.contains('open'))
            return false;
        this.animationInProcess = true;
        this.el.classList.add('open');
        if ((_a = this === null || this === void 0 ? void 0 : this.el) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
            this.el.ariaExpanded = 'true';
        this.content.classList.add('open');
        this.content.classList.remove('hidden');
        this.content.style.height = '0';
        setTimeout(function () {
            _this.content.style.height = "".concat(_this.content.scrollHeight, "px");
            _this.fireEvent('beforeOpen', _this.el);
            (0, utils_1.dispatch)('beforeOpen.hs.collapse', _this.el, _this.el);
        });
        (0, utils_1.afterTransition)(this.content, function () {
            _this.content.style.height = '';
            _this.fireEvent('open', _this.el);
            (0, utils_1.dispatch)('open.hs.collapse', _this.el, _this.el);
            _this.animationInProcess = false;
        });
    };
    HSCollapse.prototype.hide = function () {
        var _this = this;
        var _a;
        if (this.animationInProcess || !this.el.classList.contains('open'))
            return false;
        this.animationInProcess = true;
        this.el.classList.remove('open');
        if ((_a = this === null || this === void 0 ? void 0 : this.el) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
            this.el.ariaExpanded = 'false';
        this.content.style.height = "".concat(this.content.scrollHeight, "px");
        setTimeout(function () {
            _this.content.style.height = '0';
        });
        this.content.classList.remove('open');
        (0, utils_1.afterTransition)(this.content, function () {
            _this.content.classList.add('hidden');
            _this.content.style.height = '';
            _this.fireEvent('hide', _this.el);
            (0, utils_1.dispatch)('hide.hs.collapse', _this.el, _this.el);
            _this.animationInProcess = false;
        });
        if (this.content.querySelectorAll('.hs-mega-menu-content.block').length) {
            this.hideAllMegaMenuItems();
        }
    };
    // Static methods
    HSCollapse.getInstance = function (target, isInstance) {
        if (isInstance === void 0) { isInstance = false; }
        var elInCollection = window.$hsCollapseCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSCollapse.autoInit = function () {
        if (!window.$hsCollapseCollection)
            window.$hsCollapseCollection = [];
        document
            .querySelectorAll('.hs-collapse-toggle:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsCollapseCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSCollapse(el);
        });
    };
    HSCollapse.show = function (target) {
        var elInCollection = window.$hsCollapseCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection &&
            elInCollection.element.content.classList.contains('hidden'))
            elInCollection.element.show();
    };
    HSCollapse.hide = function (target) {
        var elInCollection = window.$hsCollapseCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection &&
            !elInCollection.element.content.classList.contains('hidden'))
            elInCollection.element.hide();
    };
    // Backward compatibility
    HSCollapse.on = function (evt, target, cb) {
        var elInCollection = window.$hsCollapseCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection)
            elInCollection.element.events[evt] = cb;
    };
    return HSCollapse;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSCollapse.autoInit();
    // Uncomment for debug
    // console.log('Collapse collection:', window.$hsCollapseCollection);
});
if (typeof window !== 'undefined') {
    window.HSCollapse = HSCollapse;
}
exports.default = HSCollapse;
